export default function () {
    const $questionPageContent = $(document).find('.question-page-content');
    const isRotatingPartsEnabled = $('#are_question_parts_rotatable').is(':checked');

    $questionPageContent.find('.main-tab').each(function () {
        const $part = $(this);
        const warmupsType = $part.find('.warmups-type').val();

        if ('statements' !== warmupsType) {
            return;
        }

        const $warmupsList = $part.find('[data-warmups-list]');
        const $warmupItems = $warmupsList.children('[data-warmup-item]');
        const currentWarmupsCount = $warmupItems.length;

        let warmupsCountShouldBe = 3;

        const partId = $part.attr('id');
        const isPartFirst = $questionPageContent
            .find('.questions-main-nav-tabs .nav-item:first a[href="#' + partId + '"]').length;

        if (isPartFirst) {
            // if part is first require 6 warmups
            warmupsCountShouldBe = 6;
        }

        if (isRotatingPartsEnabled) {
            // if part are rotated require 6 warmups
            warmupsCountShouldBe = 6;
        }

        const isPartBlocked = $part.find('input.block-part-checkbox:checked').length;

        if (!isPartFirst && isPartBlocked) {
            // if part are rotated but part is blocked not on the first position require 3 warmups
            warmupsCountShouldBe = 3;
        }

        if (isRotatingPartsEnabled && !isPartFirst && surveyHasOtherPartBlockedOnFirstPosition($part)) {
            // if parts are rotated
            // but part is not on the first position
            // and survey has other part blocked on first position
            // require 3 warmups
            warmupsCountShouldBe = 3;
        }

        const $partCategoryInput = $part.find('.object-choose-radio:checked');
        const currentPartCategory = $partCategoryInput.attr('id');

        if ('category-sales-pal' === currentPartCategory) {
            // if part is "salespal" category always require 6 warmups
            warmupsCountShouldBe = 6;
        }

        const differenceWarmupsNumber = warmupsCountShouldBe - currentWarmupsCount;

        if (differenceWarmupsNumber < 0) {
            // if there are more warmups than required, remove the surplus inputs
            $warmupItems.slice(differenceWarmupsNumber).remove();
        }

        if (differenceWarmupsNumber > 0) {
            // if there are not enough warmups than required, add new ones
            for (let i = 1; i <= differenceWarmupsNumber; i++) {
                $part.trigger('add-new-warmup');
            }
        }
    });

    function surveyHasOtherPartBlockedOnFirstPosition($part) {
        const partId = $part.attr('id');
        const $firstPart = $questionPageContent.find('.main-tab:first');
        const $firstPartId = $questionPageContent
            .find('.questions-main-nav-tabs .nav-item:first a')
            .attr('href');

        if ($firstPartId === '#' + partId) {
            // survey has not other part on first position
            return false;
        }

        // check first part is blocked
        return $firstPart.find('input.block-part-checkbox:checked').length;
    }
}
